import Cookie from 'js-cookie'
import _router from '@/router'
const state = {
    historyPaths:[],
	currentIndex:0,
	currentChange:false
}
const mutations = {
    addHistoryPath:(state,data)=>{
		console.log('addHistoryPath',data);
		if(state.currentChange){
			state.currentChange = false;
			return;
		}else{
			state.historyPaths.push(data);
			state.currentIndex = state.historyPaths.length - 1;
		}
    },
    delHistoryPath(state,index){
		console.log('delpathindex:',index)
		index = Number(index);
		if(index == state.currentIndex){
			state.historyPaths.splice(index,1);
			if(state.historyPaths.length>1){
				state.currentIndex--;
			}else{
				state.currentIndex = 0;
			}
			_router.history.go(-1);
		}else{
			state.historyPaths.splice(index,1);
		}
    },
	setCurrentIndex(state,index){
		index = Number(index);
		if(index == state.currentIndex){
			console.log('点击了当前标签卡')
			return false;
		}else{
			state.currentIndex = index;
			// state.currentChange = true;
			// _router.push({path:state.historyPaths[state.currentIndex].path,query:state.historyPaths[state.currentIndex].query});
			let goindex = state.historyPaths.length -1 - state.currentIndex;
			_router.history.go(goindex);
		}
		
	}
}
export default {
    namespaced:true,
    state,
    mutations
}